import { defineStore } from "pinia";
import { ref } from "vue";

export const useContactVoltalisDialogStore = defineStore("contactVoltalisDialog", () => {
  const visible = ref<boolean>(false);

  return {
    visible,
  };
});
